import styled from "styled-components";

export const PopupWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background: white;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  box-sizing: border-box;

  .content {
    width: auto;
    max-width: 60vw;
    margin: 0 auto;
    text-align: center;
  }

  .text {
    font-size: 0.95rem;
    margin-bottom: 1.5rem;

    a {
      color: #2d378c;
      font-weight: 600;
      text-decoration: none;
    }
  }

  .button-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    button {
      padding: 0.75rem;
      font-size: 1rem;
      border-radius: 8px;
      border: none;
      cursor: pointer;
    }

    .secondary-btn {
      background-color: #e0e0e0;
    }
    .primary-btn {
      background-color: #d92d20;
      color: white;
    }

    @media (min-width: 768px) {
      flex-direction: row;
      width: 100%;

      button {
        flex: 1;
      }
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
`;
